import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Icon } from 'roo-ui/components';
import Crumb from './Crumb';

const buildCrumbs = ({ crumbs, ...rest }) =>
  crumbs.reduce((accum, item, index) => {
    const next = [...accum];

    if (index) {
      next.push(<Icon key={`divider-${index}`} name="chevronRight" color="greys.alto" mx={4} data-testid="divider" />);
    }

    next.push(<Crumb key={item.title} {...item} {...rest} data-testid="crumb" />);

    return next;
  }, []);

const Breadcrumbs = (props) => <Fragment>{buildCrumbs(props)}</Fragment>;

Breadcrumbs.propTypes = {
  crumbs: PropTypes.array,
  context: PropTypes.string.isRequired,
};

Breadcrumbs.defaultProps = {
  crumbs: [],
};

export default Breadcrumbs;
